module.exports = __webpack_public_path__ + "static/img/map3.3af75a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/map3.png
// module id = 3KXX
// module chunks = 0